// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '32px',
  height: '32px',
  color: '',
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

// Component
function IconNotificationAnnouncement({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 52.267 44.986"
    >
      <circle
        fill="#052a5f"
        cx="19.5"
        cy="19.5"
        r="19.5"
        transform="translate(6.267 3.494)"
      />
      <g transform="translate(-16.793 -46.264) rotate(-16)">
        <path
          fill="#f0f4ff"
          d="M195.871,61.751a7.709,7.709,0,0,1-2.678,2.821c-1.94,1.324-5.577,2.9-11.886,2.9A1.307,1.307,0,0,0,180,68.781V81.854a1.307,1.307,0,0,0,1.307,1.307c6.309,0,9.946,1.578,11.886,2.9a7.71,7.71,0,0,1,2.678,2.821,1.3,1.3,0,0,0,2.518-.493V62.244A1.3,1.3,0,0,0,195.871,61.751Z"
          transform="translate(-164.312 0)"
        />
        <path
          fill="#dfe3f4"
          d="M198.39,226.076v13.073a1.3,1.3,0,0,1-2.518.493,7.719,7.719,0,0,0-2.678-2.821c-1.94-1.323-5.577-2.9-11.886-2.9A1.308,1.308,0,0,1,180,232.613v-6.537Z"
          transform="translate(-164.312 -150.758)"
        />
        <path
          fill="#1351aa"
          d="M5.79,176.535H1.307A1.308,1.308,0,0,1,0,175.227v-7.844a1.308,1.308,0,0,1,1.307-1.307H5.79a2.478,2.478,0,0,0-.037.436C5.765,176.536,5.722,176.154,5.79,176.535Z"
          transform="translate(0 -95.988)"
        />
        <path
          fill="#093c86"
          d="M5.79,231.305H1.307A1.308,1.308,0,0,1,0,230v-3.922H5.754C5.752,231.186,5.735,231,5.79,231.305Z"
          transform="translate(0 -150.758)"
        />
        <path
          fill="#093c86"
          d="M99.658,321.6a1.308,1.308,0,0,1-1.3,1.408H94.083a1.307,1.307,0,0,1-1.3-1.191L91.8,310.776c.327.048,3.155.025,8.036.026l-.772,3.158Z"
          transform="translate(-83.799 -228.076)"
        />
        <path
          fill="#fa6383"
          d="M72.679,136.076H64.05a3.054,3.054,0,0,0-3.05,3.05v9.587a3.054,3.054,0,0,0,3.05,3.05h8.628Z"
          transform="translate(-55.684 -68.602)"
        />
        <path
          fill="#eb4b6d"
          d="M72.679,226.076v7.844H64.05a3.054,3.054,0,0,1-3.05-3.05v-4.793Z"
          transform="translate(-55.684 -150.758)"
        />
        <path
          fill="#093c86"
          d="M113,221.512v1.3a1.307,1.307,0,0,0,2.615,0v-1.3l-1.307-.436Z"
          transform="translate(-103.152 -146.194)"
        />
        <path
          fill="#093c86"
          d="M115.615,197.307a1.307,1.307,0,1,0-2.615,0v1.314h2.615Z"
          transform="translate(-103.152 -123.304)"
        />
        <path
          fill="#fedd3c"
          d="M455.922,211.076h-2.615a1.307,1.307,0,1,0,0,2.615h2.615a1.307,1.307,0,1,0,0-2.615Z"
          transform="translate(-412.606 -137.066)"
        />
        <path
          fill="#fedd3c"
          d="M422.959,109.822l2.264-1.307a1.307,1.307,0,0,0-1.307-2.264l-2.264,1.307a1.307,1.307,0,1,0,1.307,2.264Z"
          transform="translate(-384.306 -41.216)"
        />
        <path
          fill="#fedd3c"
          d="M425.223,302.555l-2.264-1.307a1.307,1.307,0,1,0-1.307,2.264l2.264,1.307a1.307,1.307,0,1,0,1.307-2.264Z"
          transform="translate(-384.306 -219.219)"
        />
      </g>
    </svg>
  )
}

IconNotificationAnnouncement.defaultProps = defaultProps
IconNotificationAnnouncement.propTypes = propTypes

export default IconNotificationAnnouncement
